export const AuditTimelineEvents = Object.freeze({
  1: "Pre Consult",
  2: "Consultation Started",
  3: "Consultation Ended",
  4: "Consultation Paused",
  5: "Consultation Resumed",
  6: "Consultation Canceled",
  7: "FreeType Consultation",
  8: "Manual Consultation",
  9: "Template Added",
  10: "Chat Prompt",
  11: "Chat Response",
  12: "Action Performed",
  13: "Notes",
  14: "Transcription",
  15: "Feedback",
  16: "Consultation Summary",
  17: "Medications",
  18: "Allergies",
  19: "Medical Conditions",
  20: "Consultation Completed",
  21: "Patient Consent",
  22: "DemDx Completed",
  23: "Vaccinations",
  24: "Documents Uploaded",
  26:"Appointment Linked",
  27:"Consultation Pharmacist Updated"
});
